import(/* webpackMode: "eager", webpackExports: ["Prefooter"] */ "/app/apps/todoist-landing-pages/app/[locale]/features/components/prefooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/apps/todoist-landing-pages/app/[locale]/karma/components/header/header.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/[locale]/karma/components/layout.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["OneColumnSection"] */ "/app/apps/todoist-landing-pages/app/[locale]/karma/components/one-column-section/one-column-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThreeColumnSection"] */ "/app/apps/todoist-landing-pages/app/[locale]/karma/components/three-column-section/three-column-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TwoColumnSection"] */ "/app/apps/todoist-landing-pages/app/[locale]/karma/components/two-column-section/two-column-section.tsx");
